import { render, staticRenderFns } from "./AdminNotificationList.vue?vue&type=template&id=e9cb6a02&scoped=true"
import script from "./AdminNotificationList.vue?vue&type=script&lang=js"
export * from "./AdminNotificationList.vue?vue&type=script&lang=js"
import style0 from "./AdminNotificationList.vue?vue&type=style&index=0&id=e9cb6a02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9cb6a02",
  null
  
)

export default component.exports